import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import movieai from "../../Assets/Projects/movie-ai.webp";
import edoctor from "../../Assets/Projects/e-doctor.webp";
import wms from "../../Assets/Projects/wms.webp";
import kayagourmet from "../../Assets/Projects/kaya-gourmet.webp";
import bookingsystem from "../../Assets/Projects/booking-system.webp";
import hemfeinkost from "../../Assets/Projects/hem-feinkost.webp";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kayagourmet}
              isBlog={false}
              title="Kaya Gourmet Website"
              description="A modern, multi-language website for Kaya Gourmet built with React, TypeScript, and Tailwind CSS. Features include reCAPTCHA integration, responsive design, and secure, SEO-friendly contact form handling."
              demoLink="https://kayagourmet.de/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hemfeinkost}
              isBlog={false}
              title="Hem Feinkost Website"
              description="Eine moderne, benutzerfreundliche Website für ein Feinkostunternehmen mit Fokus auf mobilen Zugriff, klarer Struktur und ansprechendem Design – ideal für die Präsentation hochwertiger Lebensmittelprodukte."
              demoLink="https://hemfeinkost.de/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={wms}
              isBlog={false}
              title="Warehouse Management System"
              description="The application provides a user-friendly interface for managing products, categories, and orders to increase the efficiency and accuracy of warehouse management. It also offers various reporting tools."
              ghLink="https://github.com/uurkrtl/Capstone-Warehouse-Management-System"
              demoLink="https://capstone-wms.onrender.com/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={movieai}
              isBlog={false}
              title="Movie Recommendations with AI"
              description="An AI-powered movie recommendation app using Spring Boot, OpenAI, and TMDB API. Users enter preferences and receive tailored film suggestions. Includes Docker, MongoDB, CI/CD, and a React frontend."
              ghLink="https://github.com/uurkrtl/Movie-Recommender-AI"
              demoLink="https://movie-recommender-ai-019x.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bookingsystem}
              isBlog={false}
              title="Booking System for Sports Clubs"
              description="A booking system for sports clubs, enabling participants to register for courses and managers to organize enrollments. Built with React, Spring Boot, MongoDB, Docker, and CI/CD via GitHub Actions."
              ghLink="https://github.com/uurkrtl/Booking-System"
              demoLink="https://booking-system-3wgt.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={edoctor}
              isBlog={false}
              title="e-Doctor App"
              description="A web app for booking and managing doctor appointments with confirmation codes. Built using React, TypeScript, Spring Boot, and MongoDB. User-friendly interface, privacy-focused, and cookie-free."
              ghLink="https://github.com/uurkrtl/E-Doctor-App"
              demoLink="https://e-doctor-app.onrender.com/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
